<template>

    <form action="#" method="POST" class="form-eli">

        <div class="row align-items-center">
            <div class="col-md-4">
                <!-- Form Input -->
                <div class="form-group">
                    <label for="rut">Rut</label>
                    <input type="text" name="rut" class="form-control" v-model="form.rut" required placeholder="Rut" maxlength="16" @blur="BuscarProfesor()">
                    <p class="help-block" v-if="form.errors.has('rut')" v-text="form.errors.get('rut')"></p>
                </div>
            </div>
            <div class="col-md-8" v-if="this.msg">
                <p class="alert alert-info mb-0">{{ this.msg }}</p>
                <p class="mb-0"><small><b>Nota: </b> Si se registra un nuevo cargo, el cargo actual quedará inactivo</small></p>
            </div>
        </div>

        <div class="row">

            <div class="col-md-4">
                <!-- Form Input -->
                <div class="form-group">
                    <label for="nombres">Nombres</label>
                    <input type="text" name="nombres" class="form-control" v-model="form.nombres" required placeholder="Nombres" maxlength="191">
                    <p class="help-block" v-if="form.errors.has('nombres')" v-text="form.errors.get('nombres')"></p>
                </div>
            </div>

            <div class="col-md-4">
                <!-- Form Input -->
                <div class="form-group">
                    <label for="apellido_paterno">Apellido paterno</label>
                    <input type="text" name="apellido_paterno" class="form-control" v-model="form.apellido_paterno" required placeholder="Apellido paterno" maxlength="191">
                    <p class="help-block" v-if="form.errors.has('apellido_paterno')" v-text="form.errors.get('apellido_paterno')"></p>
                </div>
            </div>

            <div class="col-md-4">
                <!-- Form Input -->
                <div class="form-group">
                    <label for="apellido_materno">Apellido materno</label>
                    <input type="text" name="apellido_materno" class="form-control" v-model="form.apellido_materno" required placeholder="Apellido materno" maxlength="191">
                    <p class="help-block" v-if="form.errors.has('apellido_materno')" v-text="form.errors.get('apellido_materno')"></p>
                </div>
            </div>
        </div>

        <div class="row">

            <div class="col-md-4">
                <!-- Form Input -->
                <div class="form-group">
                    <label for="fecha_nacimiento">Fecha de nacimiento</label>
                    <input type="date" name="fecha_nacimiento" class="form-control" v-model="form.fecha_nacimiento" placeholder="Fecha de nacimiento">
                    <p class="help-block" v-if="form.errors.has('fecha_nacimiento')" v-text="form.errors.get('fecha_nacimiento')"></p>
                </div>
            </div>

            <div class="col-md-4">
                <!-- Form Input -->
                <div class="form-group">
                    <label for="nacionalidad_id">Nacionalidad</label>
                    <select name="nacionalidad_id" required id="nacionalidad_id" v-model="form.nacionalidad_id" class="form-control" placeholder="Seleccione nacionalidad">
                        <option v-for="nacionalidad in form_data.nacionalidades" :value="nacionalidad.id" :key="nacionalidad.codigo">{{ nacionalidad.nombre }}</option>
                    </select>
                    <p class="help-block" v-if="form.errors.has('nacionalidad_id')" v-text="form.errors.get('nacionalidad_id')"></p>
                </div>
            </div>

            <div class="col-md-4">
                <!-- Form Input -->
                <div class="form-group">
                    <label for="genero_id">Género</label>
                    <select name="genero_id" required id="genero_id" v-model="form.genero_id" class="form-control" placeholder="Seleccione género">
                        <option v-for="genero in form_data.generos" :value="genero.id" :key="genero.id">{{ genero.nombre }}</option>
                    </select>
                    <p class="help-block" v-if="form.errors.has('genero_id')" v-text="form.errors.get('genero_id')"></p>
                </div>
            </div>

        </div>

        <div class="row">

            <div class="col-md-4">
                <!-- Form Input -->
                <div class="form-group">
                    <label for="campus_id">Campus</label>
                    <select name="campus_id" required id="campus_id" v-model="form.campus_id" class="form-control" placeholder="Seleccione campus">
                        <option v-for="campus in form_data.campus" :value="campus.id" :key="campus.id">{{ campus.nombre }}</option>
                    </select>
                    <p class="help-block" v-if="form.errors.has('campus_id')" v-text="form.errors.get('campus_id')"></p>
                </div>
            </div>

            <div class="col-md-4">
                <!-- Form Input -->
                <div class="form-group">
                    <label for="area_id">Área</label>
                    <select name="area_id" required id="area_id" v-model="form.area_id" class="form-control" placeholder="Seleccione área">
                        <option v-for="area in form_data.areas" :value="area.id" :key="area.id">{{ area.nombre }}</option>
                    </select>
                    <p class="help-block" v-if="form.errors.has('area_id')" v-text="form.errors.get('area_id')"></p>
                </div>
            </div>

        </div>

        <hr>

        <div class="row">
            <div class="col-md">
                <p class="text-uppercase">Título profesional</p>
            </div>
            <div class="col-md-auto">
                <button type="button" class="btn btn-sm btn-success" @click="titulos[1]++">Agregar título profesional</button>
            </div>
        </div>

        <div class="titulo" v-for="index in titulos[1]" :key="'titulo-profesional-' + index">

            <div class="row">
                <div class="col-md">
                    <p v-if="index != 1" class="text-uppercase">Título profesional</p>
                </div>
                <div class="col-md-auto" v-if="index !=1 || form.titulo_id[1][index - 1]">
                    <button type="button" class="btn btn-sm btn-danger" @click="EliminarTitulo(1, index)">Eliminar: {{ form.titulo[1][index - 1] }}</button>
                </div>
            </div>

            <div class="row">
                <div class="col-md-4">

                    <!-- Form Input -->
                    <div class="form-group">
                        <label for="nombre_institucion[1][]">Nombre institución</label>
                        <input type="text" name="nombre_institucion[1][]" v-model="form.nombre_institucion[1][index - 1]" class="form-control" maxlength="191" placeholder="Nombre institución">
                    </div>

                </div>
                <div class="col-md-4">

                    <!-- Form Input -->
                    <div class="form-group">
                        <label for="titulo[1][]">Título</label>
                        <input type="text" name="titulo[1][]" v-model="form.titulo[1][index - 1]" class="form-control" maxlength="191" placeholder="Título">
                    </div>

                </div>
                <div class="col-md-4">

                    <!-- Form Input -->
                    <div class="form-group">
                        <label for="nacionalidad_titulo_id[1][]">País de obtención</label>
                        <select name="nacionalidad_titulo_id[1][]" v-model="form.nacionalidad_titulo_id[1][index - 1]" class="form-control">
                            <option v-for="nacionalidad in form_data.nacionalidades" :value="nacionalidad.id" :key="nacionalidad.codigo + '-1'">{{ nacionalidad.nombre }}</option>
                        </select>
                    </div>

                </div>
                <div class="col-md-4">

                    <!-- Form Input -->
                    <div class="form-group">
                        <label for="fecha_obtencion[1][]">Fecha de obtención</label>
                        <input type="date" name="fecha_obtencion[1][]" v-model="form.fecha_obtencion[1][index - 1]" class="form-control" placeholder="Fecha de obtención">
                    </div>

                </div>
            </div>

        </div>

        <hr>

        <div class="row">
            <div class="col-md">
                <p class="text-uppercase">Título grado magíster</p>
            </div>
            <div class="col-md-auto">
                <button type="button" class="btn btn-sm btn-success" @click="titulos[2]++">Agregar título</button>
            </div>
        </div>

        <div class="titulo" v-for="index in titulos[2]" :key="'titulo-magister-' + index">

            <div class="row">
                <div class="col-md">
                    <p v-if="index != 1" class="text-uppercase">Título grado magíster</p>
                </div>
                <div class="col-md-auto" v-if="index !=1 || form.titulo_id[2][index - 1]">
                    <button type="button" class="btn btn-sm btn-danger" @click="EliminarTitulo(2, index)">Eliminar: {{ form.titulo[2][index - 1] }}</button>
                </div>
            </div>

            <div class="row">
                <div class="col-md-4">

                    <!-- Form Input -->
                    <div class="form-group">
                        <label for="nombre_institucion[2][]">Nombre institución</label>
                        <input type="text" name="nombre_institucion[2][]" v-model="form.nombre_institucion[2][index - 1]" class="form-control" maxlength="191" placeholder="Nombre institución">
                    </div>

                </div>
                <div class="col-md-4">

                    <!-- Form Input -->
                    <div class="form-group">
                        <label for="titulo[2][]">Título</label>
                        <input type="text" name="titulo[2][]" v-model="form.titulo[2][index - 1]" class="form-control" maxlength="191" placeholder="Título">
                    </div>

                </div>
                <div class="col-md-4">

                    <!-- Form Input -->
                    <div class="form-group">
                        <label for="nacionalidad_titulo_id[2][]">País de obtención</label>
                        <select name="nacionalidad_titulo_id[2][]" v-model="form.nacionalidad_titulo_id[2][index - 1]" class="form-control">
                            <option v-for="nacionalidad in form_data.nacionalidades" :value="nacionalidad.id" :key="nacionalidad.codigo + '-2'">{{ nacionalidad.nombre }}</option>
                        </select>
                    </div>

                </div>
                <div class="col-md-4">

                    <!-- Form Input -->
                    <div class="form-group">
                        <label for="fecha_obtencion[2][]">Fecha de obtención</label>
                        <input type="date" name="fecha_obtencion[2][]" v-model="form.fecha_obtencion[2][index - 1]" class="form-control" placeholder="Fecha de obtención">
                    </div>

                </div>
            </div>

        </div>

        <hr>

        <div class="row">
            <div class="col-md">
                <p class="text-uppercase">Título grado doctorado</p>
            </div>
            <div class="col-md-auto">
                <button type="button" class="btn btn-sm btn-success" @click="titulos[3]++">Agregar título</button>
            </div>
        </div>

        <div class="titulo" v-for="index in titulos[3]" :key="'titulo-doctorado-' + index">

            <div class="row">
                <div class="col-md">
                    <p v-if="index != 1" class="text-uppercase">Título grado doctorado</p>
                </div>
                <div class="col-md-auto" v-if="index !=1 || form.titulo_id[3][index - 1]">
                    <button type="button" class="btn btn-sm btn-danger" @click="EliminarTitulo(3, index)">Eliminar: {{ form.titulo[3][index - 1] }}</button>
                </div>
            </div>

            <div class="row">
                <div class="col-md-4">

                    <!-- Form Input -->
                    <div class="form-group">
                        <label for="nombre_institucion[3][]">Nombre institución</label>
                        <input type="text" name="nombre_institucion[3][]" v-model="form.nombre_institucion[3][index - 1]" class="form-control" maxlength="191" placeholder="Nombre institución">
                    </div>

                </div>
                <div class="col-md-4">

                    <!-- Form Input -->
                    <div class="form-group">
                        <label for="titulo[3][]">Título</label>
                        <input type="text" name="titulo[3][]" v-model="form.titulo[3][index - 1]" class="form-control" maxlength="191" placeholder="Título">
                    </div>

                </div>
                <div class="col-md-4">

                    <!-- Form Input -->
                    <div class="form-group">
                        <label for="nacionalidad_titulo_id[3][]">País de obtención</label>
                        <select name="nacionalidad_titulo_id[3][]" v-model="form.nacionalidad_titulo_id[3][index - 1]" class="form-control">
                            <option v-for="nacionalidad in form_data.nacionalidades" :value="nacionalidad.id" :key="nacionalidad.codigo + '-3'">{{ nacionalidad.nombre }}</option>
                        </select>
                    </div>

                </div>
                <div class="col-md-4">

                    <!-- Form Input -->
                    <div class="form-group">
                        <label for="fecha_obtencion[3][]">Fecha de obtención</label>
                        <input type="date" name="fecha_obtencion[3][]" v-model="form.fecha_obtencion[3][index - 1]" class="form-control" placeholder="Fecha de obtención">
                    </div>

                </div>
            </div>

        </div>

        <hr>

        <div class="row">
            <div class="col-md-4">
                <!-- Form Input -->
                <div class="form-group">
                    <label for="tipo_categoria_id">Tipo</label>
                    <select name="tipo_categoria_id" required id="tipo_categoria_id" class="form-control" v-model="form.tipo_categoria_id" @change="onActualizarTipoCategoria()">
                        <option value="">Seleccione una opción</option>
                        <option v-for="tipo_categoria in form_data.tipos_categoria" :value="tipo_categoria.id" :key="'tipo-categoria-' + tipo_categoria.id">{{ tipo_categoria.nombre }}</option>
                    </select>
                </div>
            </div>
            <div class="col-md-4">
                <!-- Form Input -->
                <div class="form-group">
                    <label for="categoria_id">Categoría</label>
                    <select name="categoria_id" id="categoria_id" class="form-control" v-model="form.categoria_id">
                        <option v-for="categoria in form_data.categorias" :value="categoria.id" :key="'categoria-' + categoria.id">{{ categoria.nombre }}</option>
                    </select>
                </div>
            </div>
            <div class="col-md-4">
                <!-- Form Input -->
                <div class="form-group">
                    <label for="jerarquia_id">Jerarquía</label>
                    <select name="jerarquia_id" id="jerarquia_id" class="form-control" v-model="form.jerarquia_id">
                        <option v-for="jerarquia in form_data.jerarquias" :value="jerarquia.id" :key="'jerarquia-' + jerarquia.id">{{ jerarquia.nombre }}</option>
                    </select>
                </div>
            </div>
        </div>

        <hr>

        <div class="row">

            <div class="col-md-4">
                <!-- Form Input -->
                <div class="form-group">
                    <label for="fecha_incorporacion">Fecha de incorporacion</label>
                    <input type="date" name="fecha_incorporacion" class="form-control" v-model="form.fecha_incorporacion" placeholder="Fecha de incorporacion">
                    <p class="help-block" v-if="form.errors.has('fecha_incorporacion')" v-text="form.errors.get('fecha_incorporacion')"></p>
                </div>
            </div>

            <div class="col-md-4">
                <!-- Form Input -->
                <div class="form-group">
                    <label for="fecha_salida">Fecha de salida</label>
                    <input type="date" name="fecha_salida" class="form-control" v-model="form.fecha_salida" placeholder="Fecha de salida">
                    <p class="help-block" v-if="form.errors.has('fecha_salida')" v-text="form.errors.get('fecha_salida')"></p>
                </div>
            </div>

        </div>

        <div class="row">
            <div class="col-md-8">
                <!-- Form Input -->
                <div class="form-group">
                    <label for="observaciones">Observaciones</label>
                    <textarea name="observaciones" class="form-control" v-model="form.observaciones" placeholder="Observaciones" rows="5"></textarea>
                    <p class="help-block" v-if="form.errors.has('observaciones')" v-text="form.errors.get('observaciones')"></p>
                </div>
            </div>

            <div class="col-md-4" v-if="persona_id">
                <!-- Form Input -->
                <div class="form-group">
                    <label for="estado_id">Estado</label>
                    <select name="estado_id" id="estado_id" class="form-control" v-model="form.estado_id">
                        <option v-for="estado in form_data.estados" :value="estado.id" :key="'estado-' + estado.id">{{ estado.nombre }}</option>
                    </select>
                    <p class="help-block" v-if="form.errors.has('observaciones')" v-text="form.errors.get('observaciones')"></p>
                </div>
            </div>
        </div>

        <div v-if="permite_crear_user">
            <hr>

            <h4>Cuenta de usuario (opcional)</h4>

            <div class="row">
                <div class="col-md-4">
                    <!-- Form Input -->
                    <div class="form-group">
                        <label for="email">Email</label>
                        <input type="email" name="email" class="form-control" v-model="form.email" placeholder="E-mail" maxlength="191">
                        <p class="help-block" v-if="form.errors.has('email')" v-text="form.errors.get('email')"></p>
                    </div>
                </div>
            </div>
        </div>

        <!-- Form Submit -->
        <div class="form-group text-center">
            <button type="button" @click="onSubmit()" class="btn btn-eli">Guardar</button>
        </div>

    </form>

</template>

<script>
    export default {
        data() {
            return {
                form: new window.Form({
                    rut: '',
                    nombres: '',
                	apellido_paterno: '',
                    apellido_materno: '',
                    fecha_nacimiento: '',
                    nacionalidad_id: '',
                    genero_id: '',
                    campus_id: '',
                    area_id: '',
                    titulo_id: {
                        1: [],
                        2: [],
                        3: [],
                    },
                    nombre_institucion: {
                        1: [],
                        2: [],
                        3: [],
                    },
                    titulo: {
                        1: [],
                        2: [],
                        3: [],
                    },
                    nacionalidad_titulo_id: {
                        1: [],
                        2: [],
                        3: [],
                    },
                    fecha_obtencion: {
                        1: [],
                        2: [],
                        3: [],
                    },
                    tipo_categoria_id: '',
                    categoria_id: '',
                    jerarquia_id: '',
                    fecha_incorporacion: '',
                    fecha_salida: '',
                    observaciones: '',
                    estado_id: '',
                    email: '',
                    _method: 'POST',
                }),
                form_data: {
                    areas: [],
                    campus: [],
                    categorias: [],
                    estados: [],
                    generos: [],
                    jerarquias: [],
                    nacionalidades: [],
                    tipos_categoria: [],
                },
                profesor: null,
                cargo: null,
                titulos: {
                    1: 1,
                    2: 1,
                    3: 1,
                },
                msg: '',
            }
        },
        props: {
            permite_crear_user: {required: false, default: true},
            persona_id: {required: false, default: null},
        },
        mounted() {
            this.CargarAreas();
            this.CargarCampus();
            this.CargarGeneros();
            this.CargarNacionalidades();
            this.CargarTiposCategoria();

            if(this.persona_id){
                this.CargarProfesor();
                this.CargarEstados();
            }
        },
        methods: {
            BuscarProfesor() {

                const self = this;

                self.msg = '';

                // Cargamos URL
                axios.get('/administrador/profesores/buscar/' + self.form.rut)
                    .then(response => {
                        if(response.data.code == 1){

                            // Si la persona es diferente de la actual mostrar mensaje
                            if(self.persona_id && self.persona_id != response.data.persona.id){
                                window.Event.$emit('notificacion', 'error', 'El rut ingresado pertenece a otro profesor');
                                return;
                            }

                            if (response.data.msg) {
                                self.msg = response.data.msg;
                            }

                            self.profesor = response.data.persona;
                            self.cargo = response.data.cargo;

                            self.CargarFormulario();
                        }
                    })
                    .catch(function (error) {
                        console.log(error);
                    });
            },
            CargarAreas() {
                const self = this;

                // Cargamos URL
                axios.get('/data/areas')
                    .then(response => {
                        self.form_data.areas = response.data.areas;
                    })
                    .catch(function (error) {
                        console.log(error);
                    });
            },
            CargarCampus() {
                const self = this;

                // Cargamos URL
                axios.get('/data/campus')
                    .then(response => {
                        self.form_data.campus = response.data.campus;
                    })
                    .catch(function (error) {
                        console.log(error);
                    });
            },
            CargarCategorias() {
                const self = this;

                if(!self.form.tipo_categoria_id)
                    return;

                // Cargamos URL
                axios.get('/data/categorias?tipo_categoria_id=' + self.form.tipo_categoria_id)
                    .then(response => {
                        self.form_data.categorias = response.data.categorias;
                    })
                    .catch(function (error) {
                        console.log(error);
                    });
            },
            CargarEstados() {
                const self = this;

                // Cargamos URL
                axios.get('/data/estados')
                    .then(response => {
                        self.form_data.estados = response.data.estados;
                    })
                    .catch(function (error) {
                        console.log(error);
                    });
            },
            CargarFormulario() {
                this.form.rut = this.profesor.rut;
                this.form.nombres = this.profesor.nombres;
                this.form.apellido_paterno = this.profesor.apellido_paterno;
                this.form.apellido_materno = this.profesor.apellido_materno;
                this.form.fecha_nacimiento = this.profesor.fecha_nacimiento;
                this.form.nacionalidad_id = this.profesor.nacionalidad_id;
                this.form.genero_id = this.profesor.genero_id;

                if (this.cargo) {
                    this.form.campus_id = this.cargo.campus_id;
                    this.form.area_id = this.cargo.area_id;
                    this.form.tipo_categoria_id = this.cargo.tipo_categoria_id;
                    this.form.categoria_id = this.cargo.categoria_id;
                    this.form.jerarquia_id = this.cargo.jerarquia_id;
                    this.form.fecha_incorporacion = this.cargo.fecha_incorporacion;
                    this.form.fecha_salida = this.cargo.fecha_salida;
                    this.form.observaciones = this.cargo.observaciones;
                    this.form.estado_id = this.cargo.estado_id;
                }

                const self = this;

                self.form.titulo_id = {
                    1: [],
                    2: [],
                    3: [],
                };
                self.form.nombre_institucion = {
                    1: [],
                    2: [],
                    3: [],
                };
                self.form.titulo = {
                    1: [],
                    2: [],
                    3: [],
                };
                self.form.nacionalidad_titulo_id = {
                    1: [],
                    2: [],
                    3: [],
                };
                self.form.fecha_obtencion = {
                    1: [],
                    2: [],
                    3: [],
                };

                this.profesor.titulos.forEach(titulo => {
                    let index = self.form.titulo[titulo.tipo_titulo_id].length;

                    if(self.titulos[titulo.tipo_titulo_id] <= index)
                        self.titulos[titulo.tipo_titulo_id]++;

                    self.form.titulo_id[titulo.tipo_titulo_id][index] = titulo.id;
                    self.form.nombre_institucion[titulo.tipo_titulo_id][index] = titulo.nombre_institucion;
                    self.form.titulo[titulo.tipo_titulo_id][index] = titulo.titulo;
                    self.form.nacionalidad_titulo_id[titulo.tipo_titulo_id][index] = titulo.nacionalidad_id;
                    self.form.fecha_obtencion[titulo.tipo_titulo_id][index] = titulo.fecha_obtencion;
                });
            },
            CargarGeneros() {
                const self = this;

                // Cargamos URL
                axios.get('/data/generos')
                    .then(response => {
                        self.form_data.generos = response.data.generos;
                    })
                    .catch(function (error) {
                        console.log(error);
                    });
            },
            CargarJerarquias() {
                const self = this;

                if(!self.form.tipo_categoria_id)
                    return;

                // Cargamos URL
                axios.get('/data/jerarquias?tipo_categoria_id=' + self.form.tipo_categoria_id)
                    .then(response => {
                        self.form_data.jerarquias = response.data.jerarquias;
                    })
                    .catch(function (error) {
                        console.log(error);
                    });
            },
            CargarNacionalidades() {
                const self = this;

                // Cargamos URL
                axios.get('/data/nacionalidades')
                    .then(response => {
                        self.form_data.nacionalidades = response.data.nacionalidades;
                    })
                    .catch(function (error) {
                        console.log(error);
                    });
            },
            CargarProfesor() {
                const self = this;

                // Cargamos URL
                axios.get('/administrador/profesores/' + self.persona_id)
                    .then(response => {
                        if(response.data.code == 1){
                            self.profesor = response.data.persona;
                            self.cargo = response.data.cargo;

                            self.CargarFormulario();

                            // Cargamos parámetros
                            if(self.form.tipo_categoria_id){
                                self.CargarCategorias();
                                self.CargarJerarquias();
                            }
                        }
                    })
                    .catch(function (error) {
                        console.log(error);
                    });
            },
            CargarTiposCategoria() {
                const self = this;

                // Cargamos URL
                axios.get('/data/tipos-categoria')
                    .then(response => {
                        self.form_data.tipos_categoria = response.data.tipos_categoria;
                    })
                    .catch(function (error) {
                        console.log(error);
                    });
            },
            EliminarTitulo(tipo_titulo_id, index) {
                if(this.titulos[tipo_titulo_id] > 1){

                    const self = this;

                    this.$dialog.confirm('¿Confirma que desea eliminar el título seleccionado?')
                        .then(function(dialog) {
                            self.titulos[tipo_titulo_id]--;

                            // Restamos 1, puesto que el index comienza desde 1, no desde 0
                            index--;

                            self.form.titulo_id[tipo_titulo_id].splice(index,1);
                            self.form.nombre_institucion[tipo_titulo_id].splice(index,1);
                            self.form.titulo[tipo_titulo_id].splice(index,1);
                            self.form.nacionalidad_titulo_id[tipo_titulo_id].splice(index,1);
                            self.form.fecha_obtencion[tipo_titulo_id].splice(index,1);

                            window.Event.$emit('notificacion', 'success', 'El título ha sido eliminado correctamente');
                            window.Event.$emit('notificacion', 'success', 'Recuerde guardar los cambios realizados');
                        })
                        .catch(function() {
                            // console.log('Clicked on cancel');
                        });
                }
            },
            onActualizarTipoCategoria() {
                this.CargarCategorias();
                this.CargarJerarquias();
            },
            onSubmit() {
                const self = this;

                self.cargando = true;

                let url = '/administrador/profesores';
                if(self.persona_id){
                    url = url + '/' + self.persona_id;
                    self.form._method = "PATCH";
                }

                this.form.post(url)
                    .then(function(response){
                        if(response.data.code == 1){
                        	window.location.href = response.data.redirect;
                        }
                        else{
                            window.Event.$emit('notificacion', 'error', response.data.msg);
                        }
                    })
                    .catch(function (error) {
                    	if(error.response.status == 422){
	            			window.Event.$emit('errores', error);
		            	}
		            	else{
                            window.Event.$emit('notificacion', 'error', 'Se ha producido un error al registrar el profesor');
		            		console.log(error.response.data);
		            	}
                    })
                    .then(function(){
                        self.cargando = false;
                    });
            }
        }
    }
</script>
